// import React, { useEffect, useState, useRef } from "react";
// import { Modal } from "bootstrap";
// import userprofile from "../../Assets/userprofile.png";
// import "./ProfileModal.css";
// import axios from "axios";
 
// const ProfileModal = ({ show, onClose, userName, initialUserData }) => {
//   const modalRef = useRef(null);
//   const [userData, setUserData] = useState(initialUserData);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [profilePictureBlobURL, setProfilePictureBlobURL] = useState(null);
 
//   useEffect(() => {
//     if (show) {
//       let temp = localStorage.getItem("email");
//       const fetchData = async () => {
//         try {
//           const response = await axios.post("https://raasbackend.vetrinahealthcare.com/UserProfile/", { email: temp });
 
//           setUserData(response.data.user_data);
//         } catch (error) {
//           console.error("Error fetching data:", error.message);
//           setError(
//             "An error occurred while fetching user data. Please try again later."
//           );
//         } finally {
//           setLoading(false);
//         }
//       };
 
//       fetchData();
//     }
//   }, [show]);
 
//   useEffect(() => {
//     if (modalRef.current && show) {
//       const modal = new Modal(modalRef.current);
//       modal.show();
//     }
//   }, [show]);
 
//   const handleFileChange = async (event) => {
//     const file = event.target.files[0];
//     const formData = new FormData();
//     formData.append("profile_picture", file);
//     const user_id = localStorage.getItem("user_id");
//     formData.append("user_id", user_id);
 
//     try {
//       const response = await axios.post(
//         "https://raasbackend.vetrinahealthcare.com/upload-profile-picture/",
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//           responseType: "blob",
//         }
//       );
 
//       const blobURL = URL.createObjectURL(response.data);
//       setProfilePictureBlobURL(blobURL);
//       setUserData((prevUserData) => ({
//         ...prevUserData,
//         profile_picture: blobURL,
//       }));
//     } catch (error) {
//       console.error("Error uploading profile picture:", error.message);
//     }
//   };
 
//   const handleRemoveProfilePicture = async () => {
//     const user_id = localStorage.getItem("user_id");
//     try {
//       await axios.delete(`https://raasbackend.vetrinahealthcare.com/delete-profile-picture/?user_id=${user_id}`);
//       setProfilePictureBlobURL(null);
//       setUserData((prevUserData) => ({
//         ...prevUserData,
//         profile_picture: null,
//       }));
//     } catch (error) {
//       console.error("Error removing profile picture:", error.message);
//     }
//   };
 
//   useEffect(() => {
//     if (userData && !userData.profile_picture) {
//       const fetchProfilePicture = async () => {
//         try {
//           const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/profile-picture/${userData.id}/`,
//             { responseType: "blob" }
//           );
 
//           const blobURL = URL.createObjectURL(response.data);
//           setProfilePictureBlobURL(blobURL);
//         } catch (error) {
//           console.error("Error fetching profile picture:", error.message);
//         }
//       };
 
//       fetchProfilePicture();
//     }
//   }, [userData]);
 
//   useEffect(() => {
//     if (modalRef.current && !show) {
//       const modal = new Modal(modalRef.current);
//       modal.hide();
//     }
//   }, [show]);
 
//   const hideModal = () => {
//     const modalElement = modalRef.current;
//     const modalInstance = new Modal(modalElement);
//     modalInstance.hide();
//   };
 
//   return (
//     <>
//       <div
//         className="modal fade"
//         ref={modalRef}
//         tabIndex="-1"
//         aria-labelledby="exampleModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">User Profile</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//                 onClick={onClose || hideModal}
//               ></button>
//             </div>
//             <div className="modal-body">
//               <p>Welcome, {userName}</p>
//               {loading ? (
//                 <p>Loading...</p>
//               ) : error ? (
//                 <p>{error}</p>
//               ) : userData ? (
//                 <div className="d-flex flex-column align-items-center text-center mt-3">
//                   <div className="profile-picture-container">
//                     <img
//                       src={
//                         profilePictureBlobURL ||
//                         userData.profile_picture ||
//                         userprofile
//                       }
//                       alt="Profile"
//                       className="profile-picture"
//                     />
//                   </div>
//                   <div className="mt-4">
//                     <h4>{userData.name}</h4>
//                     <p className="text-secondary mb-1">{userData.email}</p>
//                     <label htmlFor="profilePicture" className="btn btn-info me-2">
//                       Upload Profile Picture
//                       <input
//                         id="profilePicture"
//                         type="file"
//                         accept="image/*"
//                         className="form-control d-none"
//                         onChange={handleFileChange}
//                       />
//                     </label>
//                     <button
//                       className="btn btn-danger"
//                       onClick={handleRemoveProfilePicture}
//                     >
//                       Remove Profile Picture
//                     </button>
//                   </div>
//                 </div>
//               ) : null}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };
 
// export default ProfileModal;
import React, { useEffect, useState, useRef, useCallback } from "react";
import { Modal } from "bootstrap";
import userprofile from "../../Assets/userprofile.png";
import "./ProfileModal.css";
import axios from "axios";

const ProfileModal = ({ show, onClose, userName, initialUserData }) => {
  const modalRef = useRef(null);
  const [userData, setUserData] = useState(initialUserData);
  const [loading, setLoading] = useState(true); // Start loading only when fetching
  const [error, setError] = useState(null);
  // State for the preview URL (can be blob URL from server or data URL from local file)
  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  const [isUploading, setIsUploading] = useState(false); // Track upload status
  const [uploadError, setUploadError] = useState(null); // Track upload specific errors

  const bootstrapModalRef = useRef(null); // Ref to store bootstrap modal instance

  // --- Initialize or destroy Bootstrap modal ---
  useEffect(() => {
    if (modalRef.current) {
      if (show && !bootstrapModalRef.current) {
        // Initialize modal instance if not already done
        bootstrapModalRef.current = new Modal(modalRef.current);
        // Add event listener for when modal is hidden
        modalRef.current.addEventListener('hidden.bs.modal', () => {
          // Call onClose when modal is fully hidden by Bootstrap events (e.g., clicking backdrop/esc)
          if (onClose) {
            onClose();
          }
           // Reset preview and errors when modal closes
          setPreviewImageUrl(null);
          setUploadError(null);
          setIsUploading(false);
        });
        bootstrapModalRef.current.show();
      } else if (!show && bootstrapModalRef.current) {
         // Ensure modal instance exists before trying to hide
         const modalInstance = Modal.getInstance(modalRef.current);
         if (modalInstance) {
           modalInstance.hide();
         }
         // We let the 'hidden.bs.modal' event handle the onClose call
      }
    }

    // Cleanup: Remove event listener and potentially destroy modal instance
    // Although Bootstrap 5 typically handles cleanup, explicit removal is safer
    const modalElement = modalRef.current;
    return () => {
      if (modalElement) {
        modalElement.removeEventListener('hidden.bs.modal', onClose);
        // Optional: Manually dispose if needed, though hide() usually suffices
        // const modalInstance = Modal.getInstance(modalElement);
        // if (modalInstance) {
        //   modalInstance.dispose();
        //   bootstrapModalRef.current = null;
        // }
      }
    };
  }, [show, onClose]);


  // --- Fetch initial user data ---
  const fetchUserData = useCallback(async () => {
      setLoading(true);
      setError(null);
      setPreviewImageUrl(null); // Reset preview on new fetch
      const tempEmail = localStorage.getItem("email");
      if (!tempEmail) {
          setError("Email not found in local storage.");
          setLoading(false);
          return;
      }
      try {
          const response = await axios.post("https://raasbackend.vetrinahealthcare.com/UserProfile/", { email: tempEmail });
          const fetchedUserData = response.data.user_data;
          setUserData(fetchedUserData);

          // If user data includes a profile picture path/URL, try to fetch it
          if (fetchedUserData?.id && !fetchedUserData.profile_picture) { // Check if ID exists but picture doesn't
                // Fetch existing picture only if no local preview is set
                // and initial data doesn't contain a direct URL we can use
                 fetchProfilePicture(fetchedUserData.id);
          } else if (fetchedUserData?.profile_picture) {
              // If the backend provides a direct URL in user_data
              // Note: This assumes profile_picture is a usable URL string
              // Adjust if it's just a path requiring prefixing
              // setPreviewImageUrl(fetchedUserData.profile_picture);
              // OR fetch it as blob if it's just an ID/path requiring auth/blob fetch
              fetchProfilePicture(fetchedUserData.id);
          }
      } catch (err) {
          console.error("Error fetching user data:", err.message);
          setError("An error occurred while fetching user data.");
      } finally {
          setLoading(false);
      }
  }, []); // No dependencies, runs once per show trigger below


  // --- Fetch existing profile picture ---
   const fetchProfilePicture = async (userId) => {
        // Avoid fetching if we already have a preview (e.g., from recent upload/local select)
        if (previewImageUrl) return;

        try {
            const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/profile-picture/${userId}/`, {
                responseType: "blob",
                 // Add Authorization header if needed
                // headers: { 'Authorization': `Bearer ${your_token}` }
            });
            // Check if response data is valid blob and has size
            if (response.data && response.data.size > 0) {
                 const blobURL = URL.createObjectURL(response.data);
                 setPreviewImageUrl(blobURL); // Set preview to fetched picture

                 // Clean up previous blob URL if it exists to prevent memory leaks
                 // Note: This assumes previewImageUrl was previously set by this function. Careful with race conditions.
                 // A more robust way might involve storing the blob URL in a ref and cleaning up in useEffect cleanup.
            } else {
                 console.log("No profile picture found or empty response.");
                 setPreviewImageUrl(null); // Ensure no broken image is shown
            }

        } catch (error) {
             // It's common to get 404 if no picture exists, treat it gracefully
            if (error.response && error.response.status === 404) {
                console.log("No profile picture found for this user.");
                setPreviewImageUrl(null);
            } else {
                 console.error("Error fetching profile picture:", error.message);
                 // Optionally set an error state specific to picture loading
            }
        }
   };


  // --- Trigger data fetch when modal is shown ---
  useEffect(() => {
    if (show) {
      fetchUserData();
    } else {
        // Clean up any existing blob URL when modal is hidden/unmounted
        if (previewImageUrl && previewImageUrl.startsWith('blob:')) {
             URL.revokeObjectURL(previewImageUrl);
        }
        setPreviewImageUrl(null); // Reset preview URL state
        setUserData(initialUserData); // Reset user data
        setLoading(true); // Reset loading state
        setError(null); // Reset error state
    }

    // Cleanup function for revoking Object URL
    return () => {
        if (previewImageUrl && previewImageUrl.startsWith('blob:')) {
             URL.revokeObjectURL(previewImageUrl);
        }
    };
  }, [show, fetchUserData, initialUserData]); // Rerun if show changes


  // --- Handle file selection and instant preview ---
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      return; // No file selected
    }

    // Check file type (optional but recommended)
    if (!file.type.startsWith('image/')) {
        setUploadError("Please select an image file.");
        return;
    }

    // Check file size (optional but recommended)
    const maxSize = 5 * 1024 * 1024; // 5 MB
     if (file.size > maxSize) {
         setUploadError("File size exceeds 5MB limit.");
         return;
     }


    // --- Instant Preview using FileReader ---
    const reader = new FileReader();
    reader.onloadend = () => {
      // Revoke previous blob URL if it exists before setting new one
      if (previewImageUrl && previewImageUrl.startsWith('blob:')) {
        URL.revokeObjectURL(previewImageUrl);
      }
      setPreviewImageUrl(reader.result); // reader.result contains the data URL (e.g., "data:image/jpeg;base64,...")
      setUploadError(null); // Clear previous errors
    };
    reader.onerror = () => {
        console.error("Error reading file");
        setUploadError("Could not read the selected file.");
    }
    reader.readAsDataURL(file); // Read file as Data URL for preview
    // --- End Instant Preview ---

    // --- Now, upload the file in the background ---
    uploadProfilePicture(file);

     // Reset file input value to allow selecting the same file again
     event.target.value = null;
  };

  // --- Upload the selected file ---
  const uploadProfilePicture = async (file) => {
    const user_id = localStorage.getItem("user_id");
    if (!user_id) {
      setUploadError("User ID not found. Cannot upload picture.");
      return;
    }

    const formData = new FormData();
    formData.append("profile_picture", file);
    formData.append("user_id", user_id);

    setIsUploading(true);
    setUploadError(null);

    try {
      // No need for responseType: 'blob' here unless the server explicitly sends back
      // the image data again after saving, which is unusual for an upload confirmation.
      // Usually, it sends back JSON confirmation { success: true, newUrl: '...' } or similar.
      await axios.post(
        "https://raasbackend.vetrinahealthcare.com/upload-profile-picture/",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
             // Add Authorization header if needed
            // 'Authorization': `Bearer ${your_token}`
          },
        }
      );
      // Upload successful
      // Optionally, you could re-fetch user data here if the backend
      // response doesn't contain the final canonical URL for the image,
      // or if you want to confirm the change persisted.
      // fetchUserData(); // Or update userData state partially if backend returns new data
      console.log("Profile picture uploaded successfully.");


    } catch (error) {
      console.error("Error uploading profile picture:", error.message);
      setUploadError("Failed to upload profile picture. Please try again.");
      // Optional: Revert preview back to original if upload fails?
      // fetchProfilePicture(userData?.id); // Refetch original picture
      // Or just leave the optimistic local preview, but show error.
    } finally {
      setIsUploading(false);
    }
  };

  // --- Handle removing the profile picture ---
  const handleRemoveProfilePicture = async () => {
    const user_id = localStorage.getItem("user_id");
     if (!user_id) {
       setUploadError("User ID not found. Cannot remove picture.");
       return;
     }

    setIsUploading(true); // Indicate activity
    setUploadError(null);

    try {
      await axios.delete(`https://raasbackend.vetrinahealthcare.com/delete-profile-picture/?user_id=${user_id}`, {
           // Add Authorization header if needed
           // headers: { 'Authorization': `Bearer ${your_token}` }
      });

      // Revoke previous blob URL if it exists
      if (previewImageUrl && previewImageUrl.startsWith('blob:')) {
          URL.revokeObjectURL(previewImageUrl);
      }
      setPreviewImageUrl(null); // Remove preview
      setUserData((prevUserData) => ({
        ...prevUserData,
        profile_picture: null, // Update local user data state if needed
      }));
      console.log("Profile picture removed successfully.");

    } catch (error) {
      console.error("Error removing profile picture:", error.message);
       setUploadError("Failed to remove profile picture. Please try again.");
    } finally {
        setIsUploading(false);
    }
  };

 // Determine the source for the image tag carefully
  const getImageSource = () => {
    // 1. Prioritize the local preview (from FileReader or fetched blob)
    if (previewImageUrl) {
      return previewImageUrl;
    }
    // 2. Fallback to profile picture URL from initial userData (if backend provides a direct URL)
    // Note: Check if userData.profile_picture is actually a URL string.
    // If it's just a path or ID, it might not be directly usable here.
    // This part depends heavily on what `https://raasbackend.vetrinahealthcare.com/UserProfile/` returns.
    // if (userData?.profile_picture && typeof userData.profile_picture === 'string' && userData.profile_picture.startsWith('http')) {
    //    return userData.profile_picture;
    // }
    // 3. Fallback to the default placeholder image
    return userprofile;
  };


  // Custom close handler to ensure state cleanup via onClose prop
  const handleCloseClick = () => {
      if (onClose) {
          onClose();
      } else {
           // Fallback if no onClose provided (shouldn't happen if parent manages state)
          const modalInstance = Modal.getInstance(modalRef.current);
          if (modalInstance) {
               modalInstance.hide();
          }
      }
  }

  return (
    <>
      {/* Modal Structure */}
      <div
        className={`modal fade ${show ? 'show' : ''}`} // Control visibility via class if needed, though Bootstrap JS handles it
        ref={modalRef}
        tabIndex="-1"
        aria-labelledby="profileModalLabel"
        aria-hidden={!show} // Make aria-hidden dynamic
        style={{ display: show ? 'block' : 'none' }} // Control display based on show prop
      >
        <div className="modal-dialog modal-dialog-centered"> {/* Optional: Center modal */}
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="profileModalLabel">User Profile</h5>
              <button
                type="button"
                className="btn-close"
                // data-bs-dismiss="modal" // Let JS handle close for better state control
                aria-label="Close"
                onClick={handleCloseClick} // Use custom handler
              ></button>
            </div>
            <div className="modal-body">
              <p>Welcome, {userName || (userData ? userData.name : 'User')}</p> {/* Use fetched name if available */}

              {loading ? (
                <div className="d-flex justify-content-center my-3">
                     <div className="spinner-border" role="status">
                         <span className="visually-hidden">Loading...</span>
                     </div>
                 </div>
              ) : error ? (
                <div className="alert alert-danger" role="alert">{error}</div>
              ) : userData ? (
                <div className="d-flex flex-column align-items-center text-center mt-3">
                  <div className="profile-picture-container mb-3"> {/* Adjusted margin */}
                    <img
                      // src={ // Determine source carefully
                      //    previewImageUrl || // Prioritize local/fetched preview
                      //   // userData.profile_picture || // Use ONLY if it's a direct URL from backend
                      //    userprofile // Fallback placeholder
                      // }
                       src={getImageSource()} // Use the helper function
                      alt="Profile"
                      className="profile-picture"
                      onError={(e) => {
                          // Handle broken image links gracefully
                          console.warn("Image failed to load, using default.");
                          e.target.onerror = null; // Prevent infinite loop if default also fails
                          e.target.src = userprofile;
                      }}
                    />
                  </div>

                    {/* Display upload status/errors */}
                     {isUploading && (
                         <div className="d-flex align-items-center justify-content-center my-2">
                             <div className="spinner-border spinner-border-sm me-2" role="status">
                                 <span className="visually-hidden">Uploading...</span>
                             </div>
                             <span>Processing...</span>
                         </div>
                     )}
                    {uploadError && <div className="alert alert-warning alert-sm mt-2">{uploadError}</div>}


                  <div className="mt-2"> {/* Reduced top margin */}
                    <h4>{userData.name}</h4>
                    <p className="text-secondary mb-3">{userData.email}</p> {/* Increased bottom margin */}

                     {/* Buttons */}
                    <div className="d-grid gap-2 d-sm-flex justify-content-sm-center"> {/* Flex layout for buttons */}
                        <label htmlFor="profilePictureInput" className={`btn btn-info ${isUploading ? 'disabled' : ''}`}>
                           {isUploading ? 'Processing...' : 'Change Picture'}
                         <input
                            id="profilePictureInput" // Changed ID to avoid conflict if multiple modals exist
                            type="file"
                            accept="image/*" // Specify accepted types
                            className="form-control d-none" // Hide default input
                            onChange={handleFileChange}
                            disabled={isUploading} // Disable while uploading
                          />
                        </label>
                        <button
                           className={`btn btn-danger ${isUploading ? 'disabled' : ''}`}
                           onClick={handleRemoveProfilePicture}
                           disabled={isUploading || !previewImageUrl} // Disable if no picture or uploading
                        >
                          Remove Picture
                        </button>
                    </div>
                  </div>
                </div>
              ) : (
                 <p>No user data available.</p> // Handle case where fetch completed but no data
              )}
            </div>
            {/* Optional: Add a modal footer for actions like Save/Close if needed */}
            {/* <div className="modal-footer">
                 <button type="button" className="btn btn-secondary" onClick={handleCloseClick}>Close</button>
             </div> */}
          </div>
        </div>
      </div>
      {/* Optional: Add backdrop manually if needed, though Bootstrap handles this */}
      {/* {show && <div className="modal-backdrop fade show"></div>} */}
    </>
  );
};

export default ProfileModal;